module.exports = __webpack_public_path__ + "img/4.cleaned_sink.580cd2ae.svg";